// Insights Page Filtering Functionality - Redesigned for Tabbed Navigation
(function($) {
    'use strict';
    
    $(document).ready(function() {
        
        // Initialize insights filtering
        initInsightsAjax();
        
        // Initialize other functionality
        initSearchFunctionality();
        initEnhancedEffects();

        function initInsightsAjax() {
            let currentPage = 1;
            let currentType = 'all';
            let isLoading = false;

            function loadInsights(reset) {
                if (isLoading) return;

                isLoading = true;

                const nextPage = reset ? 1 : currentPage + 1;
                const $grid = $('#insight-grid');
                const $btn = $('#load-more');
                const $loader = $('#loader');

                $loader.show();
                $btn.addClass('is-loading').prop('disabled', true).text('Loading...');

                $.ajax({
                    url: evergreenInsights.ajaxUrl,
                    type: 'POST',
                    dataType: 'json',
                    data: {
                        action: 'load_more_insights',
                        nonce: evergreenInsights.nonce,
                        page: nextPage,
                        content_type: currentType
                    },
                    success: function (response) {
                        if (!response.success) {
                            console.error(response);
                            return;
                        }

                        if (reset) {
                            $grid.html(response.data.html);
                        } else {
                            $grid.append(response.data.html);
                        }

                        currentPage = response.data.currentPage;

                        if (response.data.hasMore) {
                            $btn
                                .show()
                                .removeClass('is-loading')
                                .prop('disabled', false)
                                .text('Load More');
                        } else {
                            $btn.hide();
                        }

                        initEnhancedEffects();
                    },
                    error: function (xhr) {
                        console.error('AJAX Error:', xhr.status, xhr.statusText);
                        $btn.removeClass('is-loading').prop('disabled', false).text('Load More');
                    },
                    complete: function () {
                        isLoading = false;
                        $loader.hide();
                    }
                });
            }

            $('.insights-filters .filter-btn').on('click', function (e) {
                e.preventDefault();

                $('.insights-filters .filter-btn').removeClass('active');
                $(this).addClass('active');

                currentType = $(this).data('content-type') || 'all';
                currentPage = 1;

                loadInsights(true);
            });

            $(document).on('click', '#load-more', function (e) {
                e.preventDefault();
                loadInsights(false);
            });
        }
        
        function initSearchFunctionality() {
            // Enhanced search functionality
            var searchTimeout;
            $('.search-widget input[type="search"]').on('input', function() {
                var $input = $(this);
                var searchTerm = $input.val().toLowerCase().trim();
                
                clearTimeout(searchTimeout);
                searchTimeout = setTimeout(function() {
                    performSearch(searchTerm);
                }, 300);
            });
            
            function performSearch(searchTerm) {
                if (searchTerm.length > 2) {
                    $('.insight-item').each(function() {
                        var $item = $(this);
                        var title = $item.find('h3 a').text().toLowerCase();
                        var excerpt = $item.find('.insight-excerpt').text().toLowerCase();
                        
                        if (title.includes(searchTerm) || excerpt.includes(searchTerm)) {
                            $item.removeClass('filtered-out search-hidden').css({
                                'opacity': '1',
                                'transform': 'translateY(0)',
                                'display': ''
                            });
                        } else {
                            $item.addClass('search-hidden').css({
                                'opacity': '0.3',
                                'transform': 'translateY(10px)'
                            });
                        }
                    });
                    
                    // Reset filter buttons to show search is active
                    $('.insights-filters .filter-btn').removeClass('active');
                    $('.insights-filters .filter-btn[data-filter="*"]').addClass('active');
                    
                } else if (searchTerm.length === 0) {
                    // Reset search
                    $('.insight-item').removeClass('search-hidden').css({
                        'opacity': '1',
                        'transform': 'translateY(0)',
                        'display': ''
                    });
                }
            }
        }
        
        
        function initEnhancedEffects() {
            // Enhanced card hover effects
            $('.insight-card').on('mouseenter', function() {
                $(this).find('.read-more').addClass('hover-effect');
                $(this).css('transform', 'translateY(-2px)');
            }).on('mouseleave', function() {
                $(this).find('.read-more').removeClass('hover-effect');
                $(this).css('transform', 'translateY(0)');
            });
            
            // Smooth scroll for read more links
            $('.read-more').on('click', function(e) {
                $(this).addClass('clicked');
                // Allow normal link behavior
            });
            
            // Podcast item interactions
            $('.podcast-item .listen-link').on('click', function(e) {
                e.preventDefault();
                var $link = $(this);
                $link.text('Loading...');
                
                setTimeout(function() {
                    $link.text('▶ Playing');
                }, 1000);
            });
        }
        
        // Mobile responsive enhancements
        function initMobileEnhancements() {
            if ($(window).width() < 768) {
                // Mobile filter toggle
                var $filterContainer = $('.insights-filters');
                if ($filterContainer.length && !$filterContainer.hasClass('mobile-enhanced')) {
                    $filterContainer.addClass('mobile-enhanced');
                    
                    // Add mobile toggle button
                    $filterContainer.before('<button class="mobile-filter-toggle button secondary small">Filter Content</button>');
                    
                    $('.mobile-filter-toggle').on('click', function() {
                        $filterContainer.toggleClass('mobile-open');
                        $(this).text($filterContainer.hasClass('mobile-open') ? 'Hide Filters' : 'Filter Content');
                    });
                }
            }
        }
        
        // Initialize mobile enhancements
        initMobileEnhancements();
        
        // Re-initialize on window resize
        $(window).on('resize', function() {
            setTimeout(initMobileEnhancements, 250);
        });
        
        // Intersection Observer for scroll animations (if supported)
        if ('IntersectionObserver' in window) {
            const observerOptions = {
                threshold: 0.1,
                rootMargin: '0px 0px -50px 0px'
            };
            
            const insightObserver = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add('animate-in');
                    }
                });
            }, observerOptions);
            
            // Observe insight cards
            $('.insight-card').each(function(index) {
                var $card = $(this);
                $card.css('animation-delay', (index * 100) + 'ms');
                insightObserver.observe(this);
            });
        }
    });

})(jQuery);